import { useEffect } from 'react';

/**
 * Hook to execute inline scripts found in HTML content
 * Searches for <script> tags and executes their content safely
 *
 * @param content - The HTML content string that may contain script tags
 * @param shouldExecute - Whether scripts should be executed (based on feature flag)
 */
export const useHtmlScriptExecution = ({
  content,
  flagAxpBuilderHtmlPreview = true,
}: {
  content: string;
  flagAxpBuilderHtmlPreview?: boolean;
}) => {
  useEffect(() => {
    if (!flagAxpBuilderHtmlPreview) {
      return;
    }

    const getScripts = (startIndex = 0) => {
      const start = content.indexOf('<script', startIndex);

      if (start > -1) {
        const end = content.indexOf('</script>', start) + '</script>'.length;
        const script = content.substr(start, end - start);
        const rawScript = /<script>([\s\S]*?)<\/script>/.exec(script)?.[1];

        if (!rawScript) {
          return;
        }

        let executeScript;

        try {
          // eslint-disable-next-line no-new-func
          executeScript = new Function(rawScript);
          // eslint-disable-next-line no-empty
        } catch {}

        executeScript?.();

        if (end <= content.length - 1) {
          getScripts(end);
        }
      }
    };

    getScripts();
  }, []);
};
